import { useMutation } from '@apollo/client';
import { Setting } from '../../shared/types';
import { CITRIN_CREATE_SETTING, CreateSettingResponse, CreateSettingRequest } from '..';

type CreateMutationFunction = (request: Setting) => Promise<Setting>;
export const useCreateSettingMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateSettingResponse, CreateSettingRequest>(CITRIN_CREATE_SETTING);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createSetting;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
